import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";
import { Grid, Typography } from "@material-ui/core/";
import Button from "@material-ui/core/Button";
import Modal from "@material-ui/core/Modal";
import TextField from "@material-ui/core/TextField";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import {
  forgotPasswordRequest,
  setMessage,
} from "../../reduxSlices/forgotPasswordslice";

import logo from "../../assests/logo-blue.png";
import Aux from "../../hoc/Auxilliary";
import { isObjectEmpty } from "../../utils/general";
import SnackBar from "../SnackBar";
import forgotPasswordStyle from "./forgotPassword.module.css";

import localizedStrings from "../../utils/localize";
const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  container: {
    margin: "0",
    padding: "1rem 0",
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  logoAvatar: {
    width: "100%",
    height: "auto",
    margin: "0 auto",
    paddingBottom: "0.7rem",
  },
  formControl: {
    display: "flex",
    width: "100%",
  },

  submit: {
    textAlign: "right",
  },
}));

function ForgotPasswordPage(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const message = useSelector((state) => state.forgotPasswordRequest.message);
  const [email, setEmail] = useState("");
  const [isValid, setIsValid] = useState(false);
  let emailExp =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const [showSnackBar, setShowSnackBar] = useState({
    status: false,
    message: "",
  });
  const goBack = () => {
    setIsValid(false);
    setEmail("");
    props.onClose();
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    let status = { ...showSnackBar };
    status.status = false;
    setShowSnackBar(status);
    dispatch(forgotPasswordRequest({ email }));
    setEmail("");
    props.onClose();
  };
  const textFieldChangeHandler = (event) => {
    if (event.target.name === "email") {
      setIsValid(emailExp.test(String(event.target.value)));
    }
    setEmail(event.target.value);
  };
  const handleSnackBarClose = () => {
    let status = { ...showSnackBar };
    status.status = false;
    setShowSnackBar(status);
    dispatch(setMessage({}));
    setEmail("");
  };

  useEffect(() => {
    if (!isObjectEmpty(message) && message !== undefined) {
      let status = { ...showSnackBar };
      status.status = true;
      status.message = message;
      setShowSnackBar(status);
    }
  }, [message]);
  const [labelName, setLabelName] = useState({
    email: localizedStrings.forgotPassword.email,
  });

  const [emailErrorMsg, setEmailPasswordMsg] = useState(
    localizedStrings.forgotPassword.emailErrorMsg,
  );
  const language = useSelector((state) => state.language.language);
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
    setLabelName({ email: localizedStrings.forgotPassword.email });
    setEmailPasswordMsg(localizedStrings.forgotPassword.emailErrorMsg);
  }, [language]);

  return (
    <Aux>
      <div>
        <SnackBar
          open={showSnackBar.status}
          message={showSnackBar.message}
          handleClose={handleSnackBarClose}
        />
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={props.open}
          closeAfterTransition
          onClose={props.onClose}
        >
          <div className={forgotPasswordStyle.forgotPasswordContainer}>
            <div className={forgotPasswordStyle.forgotPasswordContent}>
              <header className={forgotPasswordStyle.header}>
                <Typography style={{ marginLeft: "0.5rem" }}>
                  {localizedStrings.forgotPassword.forgotPassword}
                </Typography>
              </header>
              <Grid>
                <div className={classes.logoAvatar}>
                  <img src={logo} width="100%" alt="logo" />
                </div>
              </Grid>
              <form className={classes.form} onSubmit={handleSubmit}>
                <TextField
                  label={labelName.email}
                  fullWidth
                  type="email"
                  name="email"
                  className={classes.email}
                  value={email}
                  onChange={textFieldChangeHandler}
                  InputProps={{
                    endAdornment: (
                      <MailOutlineIcon style={{ color: "#959595" }} />
                    ),
                  }}
                />
                {!isValid && (
                  <Typography style={{ color: "#f50057", fontSize: "0.8rem" }}>
                    {emailErrorMsg}
                  </Typography>
                )}
                <div className={classes.formControl}>
                  <Typography
                    component="div"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: "1rem",
                      width: "100%",
                    }}
                  >
                    <Button onClick={goBack} variant="outlined" color="primary">
                      {" "}
                      {localizedStrings.forgotPassword.back}
                    </Button>
                    <Button
                      variant="contained"
                      disabled={!isValid}
                      onClick={handleSubmit}
                      color="primary"
                    >
                      {" "}
                      {localizedStrings.forgotPassword.submit}
                    </Button>
                  </Typography>
                </div>
              </form>
            </div>
          </div>
        </Modal>
      </div>
    </Aux>
  );
}

export default ForgotPasswordPage;
